export default "__VITE_ASSET__CrHDjoaN__"